
import { Button } from "@/components/ui/button";
import { Save, Loader2 } from "lucide-react";

interface SiteSettingsHeaderProps {
  onSave: () => void;
  saving: boolean;
}

export const SiteSettingsHeader = ({ onSave, saving }: SiteSettingsHeaderProps) => {
  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
      <div>
        <h2 className="text-2xl font-bold text-teedee-blue">Site Settings</h2>
        <p className="text-gray-600">Manage your site's contact information and general settings</p>
      </div>
      <Button onClick={onSave} disabled={saving} className="bg-bobo-green hover:bg-bobo-green/90 w-full sm:w-auto">
        {saving ? (
          <Loader2 className="h-4 w-4 animate-spin mr-2" />
        ) : (
          <Save className="h-4 w-4 mr-2" />
        )}
        Save Changes
      </Button>
    </div>
  );
};
